/**
 * This component interacts with the label for price facets section.
 */
import { store$ } from '@redux/store';
import { combineLatest, distinctUntilChanged, map } from 'rxjs';
import { selectBathrooms, selectBedrooms } from '../redux/selectors';
import Bedroom from './bedroom';
import Bathroom from './bathroom';

export default class BedroomAndBathroomFilterLabel {
  constructor(bedroomAndBathRoomLabel) {
    this.bedroomAndBathRoomLabel = bedroomAndBathRoomLabel;
    this.bedroomElement = document.querySelector('[data-bedrooms-group]');
    this.bedroomLabel = bedroomAndBathRoomLabel.querySelector('[data-label-bedroom]');

    this.bathroomElement = document.querySelector('[data-bathrooms-group]');
    this.bathroomLabel = bedroomAndBathRoomLabel.querySelector('[data-label-bathroom]');

    (() => new Bedroom(this.bedroomElement))();
    (() => new Bathroom(this.bathroomElement))();

    const onBedroomChange$ = BedroomAndBathroomFilterLabel.onBedroomChange();
    onBedroomChange$.subscribe(this.changeBedroomLabel.bind(this));
    const onBathroomChange$ = BedroomAndBathroomFilterLabel.onBathroomChange();
    onBathroomChange$.subscribe(this.changeBathroomLabel.bind(this));

    combineLatest([onBedroomChange$, onBathroomChange$]).subscribe(this.toggleActiveClass.bind(this));
  }

  static onBathroomChange() {
    return store$.pipe(map(selectBathrooms), distinctUntilChanged());
  }

  static onBedroomChange() {
    return store$.pipe(map(selectBedrooms), distinctUntilChanged());
  }

  changeBathroomLabel(value) {
    if (value) {
      this.bathroomLabel.innerText = `${value}+ Ba`;
      return;
    }
    this.bathroomLabel.innerText = `Bath`;
  }

  changeBedroomLabel(value) {
    if (value) {
      this.bedroomLabel.innerText = `${value}+ Br`;
      return;
    }
    this.bedroomLabel.innerText = `Bed`;
  }

  /**
   * toggleActiveClass: Adds the active class to the label if the minimumSliderValue and the maximumSliderValue
   * are different than the slider's minimum and maximum values.
   */
  toggleActiveClass(facts) {
    const [minimumBedroom, minimumBathroom] = facts;
    if (minimumBedroom || minimumBathroom) {
        this.bedroomAndBathRoomLabel.classList.add('nhs-c-select__label--big-text',
            'nhs-mq-select__label--big-text-medium',
            'nhs-mq-select__label--big-text-bed-bath-large',
            'nhs-c-select-button--active');
      return;
    }
      this.bedroomAndBathRoomLabel.classList.remove('nhs-c-select__label--big-text',
          'nhs-mq-select__label--big-text-medium',
          'nhs-mq-select__label--big-text-bed-bath-large',
          'nhs-c-select-button--active');
  }
}
